module.exports = __webpack_public_path__ + "img/middle_background.c723f0fe.png";